import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class selfcreditService {

  constructor(private http: HttpClient) { }
  
  createCustomer(dataRequest){
    return this.http.post<any>(environment.url + environment.Customer + '/create', dataRequest);
  }

  saveUser(objUser) {
    return this.http.post<any>(environment.url + environment.Customer + '/CreateCreditRequest', objUser)
  }

  SaveCodebtor(objUser) {
    return this.http.post<any>(environment.url + environment.Customer + '/CreateCodebtRequest', objUser)
  }

  saveCreditInfo(objUser) {
    return this.http.post<any>(environment.url + environment.Customer + '/AddExtraInfoSelfCredit', objUser)
  }

  saveDocCredit(objUser) {
    return this.http.post<any>(environment.url + environment.Customer + '/AddDocument', objUser)
  }

  getRequestStatus(id: string) {
    return this.http.get<any>(environment.url + environment.Customer + "/ValidateStatus" + '?id=' + id)
  }

  get(id: string) {
    return this.http.get<any>(environment.url + environment.Customer + "/GetByDocumentNumber" + '?documentNumber=' + id)
  }

  editUser(objUser) {
    return this.http.post<any>(environment.url + environment.Customer + '/UpdateCreditRequest', objUser)
  }

  getUser(userId){
    return this.http.get<any>(environment.url + environment.User + '/get?id='+userId)
  }

  getUserPublic(userId){
    return this.http.get<any>(environment.url + environment.User + '/get/public?id='+userId)
  }

  CancelRequest(document: number) {
    return this.http.post<any>(
      `${environment.url}${environment.Credit}/CancelCreditRequest`, 
      document,  // Enviar el valor directamente
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  AcceptCredit(id: number) {
    return this.http.post<any>(
      `${environment.url}${environment.Credit}/AcceptCredit`, 
      id,  // Enviar el valor directamente
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  getSettings(){
    return this.http.get<any>(environment.url + environment.Settings + '/get')
  }
}
